(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home"] && !Shopify.designMode) return;
  try {
    
  // FAQ Accordion
  (function() {
    const initFaq = () => {
      const faqQuestions = document.querySelectorAll('.faq-question');
      faqQuestions.forEach((button) => {
        if (button.dataset.initialized) return;
        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          const answer = button.parentElement.nextElementSibling;

          // Cierra todos los demás acordeones abiertos
          if (!isExpanded) {
            faqQuestions.forEach((otherButton) => {
              if (otherButton !== button && otherButton.getAttribute('aria-expanded') === 'true') {
                otherButton.setAttribute('aria-expanded', 'false');
                const otherAnswer = otherButton.parentElement.nextElementSibling;
                otherAnswer.hidden = true;
                otherAnswer.style.maxHeight = '0px';
              }
            });
          }

          // Abre o cierra el actual
          button.setAttribute('aria-expanded', !isExpanded);
          answer.hidden = isExpanded;

          if (!isExpanded) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          } else {
            answer.style.maxHeight = '0px';
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFaq);
    } else {
      initFaq();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
